import React from 'react'

export const CommonPage = ({ pageTitle, ckData, loading }) => {
    return (
        <div>
            <div className="container p-0  " style={{ minWidth: "100vw", width: "100%", marginTop: "40px" }}>
                <div className="col-12 p-lg-5 p-md-4 mt-lg-0 mt-md-3 mt-3 dashboard-wrapper">

                    <div className="row dashboard-content mt-lg-0 mt-md-3 mt-3">
                        <div className="col-12">
                            <h2>{pageTitle}</h2>
                            <div className="row bg-light border border-1 p-3 m-1 rounded">
                                {loading ? (
                                    <div>Loading...</div> // Loading indicator
                                ) : (
                                    <div className="col-12 mb-4">
                                        {/* Render the HTML content */}
                                        <div
                                            className="about-us-content"
                                            dangerouslySetInnerHTML={{ __html: ckData }}
                                        />
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
